import Vue from 'vue'
import store from '../store'
import router from '../router'

export default {
  signOut () {
    Vue.http.post('/api/logout/').then(response => {
      store.commit('user/authed', false)
      store.commit('user/verified', false)
      // workaround to ensure layer load after signout
      // router.push('/login')
      location.href = `/login`
      
    }, response => {
      this.$notify({
        title: 'ERROR',
        text: 'Could not sign out',
        type: 'error'
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js